var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { hearingLevelsExplained } from '@/constants/hearing-ability-explained.constant';
import { Typography } from '@mui/material';
import { cn } from 'hx-util';
export function HearingAbilityContent() {
    return (_jsxs("div", __assign({ className: "flex flex-col gap-5 w-fit md:gap-12" }, { children: [_jsx(Typography, __assign({ variant: 'h2', className: "font-bold mb-1" }, { children: "Hearing ability explained:" })), hearingLevelsExplained.map(function (_a) {
                var title = _a.title, description = _a.description, color = _a.color, icon = _a.icon;
                return (_jsxs("div", __assign({ className: "flex flex-col items-center md:items-start gap-1 md:flex-row md:gap-8" }, { children: [_jsx("img", { src: icon, alt: 'Information icon', className: 'h-10 w-10' }), _jsxs("div", __assign({ className: 'flex flex-col md:items-start' }, { children: [_jsx(Typography, __assign({ variant: 'body1', className: cn('text-xl text-center md:text-left font-semibold md:m-0', color) }, { children: title })), _jsx(Typography, __assign({ variant: 'body1', className: "text-center font-medium text-lg md:text-xl md:text-left max-w-80" }, { children: description }))] }))] }), title));
            })] })));
}
